import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import FooterFile from "../../footer/FooterFile";

class AcceptableUse extends Component<RouteComponentProps> {
    constructor(props: RouteComponentProps) {
        super(props);
    }

    setDate = () => {};

    render() {
        return <FooterFile FileName="AcceptableUse" />;
    }
}

export default withRouter(AcceptableUse);
